import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchAllRooms } from '../redux/actions/getRooms';
import { addRoom } from 'modules/Admin/redux/actions/addRoom';
import { deleteRoom } from '../redux/actions/deleteRoom';
import Modal from 'base/components/Modal';
import AddNewRoom from '../components/AddRoom';
import Toolbar from 'base/components/common/Toolbar';

class RoomsAdminView extends Component {
  state = {
    addingIsOpen: false
  }

  handleAdd = (values) => {
    this.props.dispatch(addRoom(values))
  }

  handleDeleteRoom = (id) => {
    console.log("Usunięto: ", id);
    this.props.dispatch(deleteRoom(id));
  }

  componentDidMount = () => {
    this.props.dispatch(fetchAllRooms());
    // console.log('xd')
  }

  render() {
    const { addingIsOpen } = this.state;
    const { data, isLoading, error } = this.props.rooms;

    if (isLoading) return(<p>Loading</p>);

    return (
      <div>
        <Toolbar title="< Panel admina | Rooms" titleUrl="/admin" />
      <div className="rooms-wrapper">
        <button onClick={() => this.setState({addingIsOpen: true})}>Dodaj pokuj</button>
        <table className="rooms-table">
          <thead>
            <tr>
              <th>Numer pokoju</th>
              <th>Wszystkie miejsca</th>
              <th>Wolne miejsca</th>
            </tr>
          </thead>
          <tbody>

           { data.length ? data.map( room =>
            <tr key={room.roomName}>
              <td>{room.roomName}</td>
              <td>{room.size}</td>
              <td>{room.freeSize}</td>
              <td><i className="material-icons" onClick={() => this.handleDeleteRoom(room._id)}>delete</i></td>
           </tr>)
           : (<p>Coś się zjebało, albo nie ma pokoi XD {error}</p>)
          }
          </tbody>
        </table>

        {
          addingIsOpen &&
          <Modal onBlurClick={() => this.setState({addingIsOpen: false})}>
            <AddNewRoom onSubmit={this.handleAdd} />
          </Modal>
        }
      </div>
      </div>
    )
  }
};

export default connect((state) => ({
  rooms: state.rooms
}))(RoomsAdminView);



// WEBPACK FOOTER //
// ./src/modules/Admin/views/RoomsAdminView.js